export enum SLPFormStep {
  HOPES_GOALS_AMBITIONS = 1,
  PERSONAL_SMART_GOALS = 2,
  WHERE_TO_FROM_HERE = 3,
}

export enum AchievementRatingGAS {
  Worse = 1,
  SameAsBaseline = 2,
  PartiallyAchieved = 3,
  AsExpected = 4,
  ALittleBetter = 5,
  MuchBetter = 6,
}
